import { render, staticRenderFns } from "./EditServiceDocumentPage.vue?vue&type=template&id=68a5206c&scoped=true"
import script from "./EditServiceDocumentPage.vue?vue&type=script&lang=js"
export * from "./EditServiceDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5206c",
  null
  
)

export default component.exports